const { formatMoney } = window.BAO.Utils

export class ProductSubtotal extends window.BAO.CustomElement() {
  static get observedAttributes () {
    return ['price', 'quantity']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  attributeChangedCallback (name, oldValue, newValue) {
    const isANumber = isNaN(parseInt(newValue, 10)) === false

    switch (name) {
      case 'price': {
        if (!isANumber) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handlePriceUpdateSideEffects(parseInt(newValue, 10))

        break
      }
      case 'quantity': {
        if (!isANumber) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handleQuantityUpdateSideEffects(parseInt(newValue, 10))

        break
      }
    }
  }

  setupListeners () {
    super.setupListeners()

    if (
      !this.hasAttribute('price') ||
      !this.hasAttribute('quantity') ||
      !this.productDetailBlocksEl
    ) {
      return
    }

    this.onQuantityUpdate = this.onQuantityUpdate.bind(this)
    this.onVariantChange = this.onVariantChange.bind(this)

    this.listeners.add(
      this.productDetailBlocksEl,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.onQuantityUpdate,
    )

    this.listeners.add(
      this.productDetailBlocksEl,
      window.BAO.EVENTS.VARIANT.CHANGE,
      this.onVariantChange,
    )
  }

  /**
   * @param {Event} event
   *
   * @returns {void}
   */
  onQuantityUpdate (event) {
    if (!event?.detail?.value) return
    this.currentQuantity = event.detail.value
  }

  /**
   * @param {Event} event
   *
   * @returns {void}
   */
  onVariantChange (event) {
    if (!event?.detail?.variant?.data?.price) return
    this.currentPrice = event.detail.variant.data.price
  }

  /**
   * @param {Number} quantity
   *
   * @returns {void}
   */
  handleQuantityUpdateSideEffects (quantity) {
    this.renderSubTotal(this.currentPrice * quantity)
  }

  /**
   * @param {Number} price
   *
   * @returns {void}
   */
  handlePriceUpdateSideEffects (price) {
    this.renderSubTotal(price * this.currentQuantity)
  }

  /**
   * @param {Number} subtotal
   *
   * @returns {void}
   */
  renderSubTotal (subtotal) {
    this.innerHTML = `(${formatMoney(subtotal)})`
  }

  /**
   * @returns {Number}
   */
  get currentPrice () {
    return parseInt(this.getAttribute('price'), 10) || null
  }

  /**
   * @returns {Number}
   */
  get currentQuantity () {
    return parseInt(this.getAttribute('quantity'), 10) || null
  }

  /**
   * @param {Number} price
   *
   * @returns {void}
   */
  set currentPrice (price) {
    this.setAttribute('price', String(price))
  }

  /**
   * @param {Number} quantity
   *
   * @returns {void}
   */
  set currentQuantity (quantity) {
    this.setAttribute('quantity', String(quantity))
    this.setAttribute('aria-hidden', String(quantity <= 1))
  }

  /**
   * @returns {HTMLElement|null}
   */
  get productDetailBlocksEl () {
    return this.closest('[data-product-detail-blocks]')
  }
}

if (!customElements.get('product-subtotal')) {
  customElements.define('product-subtotal', ProductSubtotal)
}
